import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mainArea" }
const _hoisted_2 = { class: "loginArea" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "loginTitle",
  style: {"margin-bottom":"20px"}
}, "- 회원가입 -", -1)
const _hoisted_5 = {
  class: "memCrBox",
  sytle: "width:800px"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "memCrTitle" }, "이름", -1)
const _hoisted_7 = { class: "memCrCon nameTextInput" }
const _hoisted_8 = { class: "sexSelect" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "memCrTitle" }, "생년월일", -1)
const _hoisted_10 = { class: "memCrCon nameTextInput" }
const _hoisted_11 = { class: "sexSelect" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "memCrTitle" }, "보직", -1)
const _hoisted_13 = { class: "memCrCon" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "memCrTitle" }, "소속", -1)
const _hoisted_15 = { class: "memCrCon" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "memCrTitle" }, "휴대폰 번호", -1)
const _hoisted_17 = { class: "memCrCon" }
const _hoisted_18 = { class: "memCrBoxSubText memCrCon" }
const _hoisted_19 = { class: "noBorder" }
const _hoisted_20 = { class: "allCheck" }
const _hoisted_21 = { class: "allCheckBorder" }
const _hoisted_22 = {
  class: "noBorder",
  style: {"margin-top":"20px"}
}
const _hoisted_23 = { class: "allCheck" }
const _hoisted_24 = { class: "noBorder" }
const _hoisted_25 = { class: "allCheck" }
const _hoisted_26 = { class: "loginBlock" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", null, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                readonly: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.api.user_name) = $event))
              }, null, 512), [
                [_vModelText, $data.api.user_name]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: _normalizeClass(["man", {'select' : $data.api.gender_name=='남'}])
              }, "남", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["woman", {'select' : $data.api.gender_name=='여'}])
              }, "여", 2)
            ])
          ]),
          _createElementVNode("li", null, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                readonly: "",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.api.birth_date) = $event))
              }, null, 512), [
                [_vModelText, $data.api.birth_date]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: _normalizeClass(["man", {'select' : $data.api.date_div_name=='양'}])
              }, "양", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["woman", {'select' : $data.api.date_div_name=='음'}])
              }, "음", 2)
            ])
          ]),
          _createElementVNode("li", null, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                readonly: "",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.api.duty_name) = $event))
              }, null, 512), [
                [_vModelText, $data.api.duty_name]
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                readonly: "",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.api.belo_txt) = $event))
              }, null, 512), [
                [_vModelText, $data.api.belo_txt]
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                readonly: "",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.api.phone_number) = $event))
              }, null, 512), [
                [_vModelText, $data.api.phone_number]
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "인증번호를 입력해 주세요",
              style: {"width":"200px","margin-right":"10px"},
              maxlength: "5",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.ui.crtf_txt) = $event))
            }, null, 512), [
              [_vModelText, $data.ui.crtf_txt]
            ]),
            _withDirectives(_createElementVNode("button", {
              class: "grayBtn",
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.crtf_txt_send()))
            }, "인증번호 전송", 512), [
              [_vShow, $data.ui.crtf_stat==1]
            ]),
            _withDirectives(_createElementVNode("button", {
              class: "blueBtn",
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.crtf_txt_check()))
            }, "인증번호 확인", 512), [
              [_vShow, $data.ui.crtf_stat==2]
            ]),
            _withDirectives(_createElementVNode("button", {
              class: "yellowBtn",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.alert('인증완료되었으니 회원가입을 진행해 주시면됩니다.')))
            }, "인증완료", 512), [
              [_vShow, $data.ui.crtf_stat==3]
            ]),
            _withDirectives(_createElementVNode("div", { class: "blue bold mgT05" }, "남은 시간 : " + _toDisplayString($data.ui.resTimeData), 513), [
              [_vShow, $data.ui.crtf_stat==2]
            ])
          ]),
          _createElementVNode("li", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.ui.is_all_check) = $event)),
                  onChange: _cache[10] || (_cache[10] = ($event: any) => ($options.check_all()))
                }, null, 544), [
                  [_vModelCheckbox, $data.ui.is_all_check]
                ]),
                _createTextVNode(" 전체동의 ")
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_22, [
            _createElementVNode("label", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($data.ui.is_pers) = $event))
              }, null, 512), [
                [_vModelCheckbox, $data.ui.is_pers]
              ]),
              _createTextVNode(" 개인정보 수집 및 이용동의 (필수) "),
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$root.goPrivacy(1))),
                class: "detailView"
              }, "자세히 보기")
            ])
          ]),
          _createElementVNode("li", _hoisted_24, [
            _createElementVNode("label", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($data.ui.is_agre) = $event))
              }, null, 512), [
                [_vModelCheckbox, $data.ui.is_agre]
              ]),
              _createTextVNode(" 서비스 이용 약관 동의 (필수) "),
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$root.goPrivacy(2))),
                class: "detailView"
              }, "자세히 보기")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            class: "idpwBtn",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$movePage('/app/login')))
          }, "취소"),
          _createTextVNode("   "),
          _createElementVNode("button", {
            class: "loginBtn",
            onClick: _cache[16] || (_cache[16] = ($event: any) => ($options.joinMember()))
          }, "상생레터 가입")
        ])
      ])
    ])
  ]))
}